import { useState, useCallback } from 'react';
import { defaultConfig, IConfig, IConfigHook } from './ConfigContext';

export default function useConfig(): IConfigHook {
  const [config, setConfigState] = useState<IConfig>(defaultConfig);

  const setConfig = useCallback((_config: IConfig) => {
    setConfigState(_config);
  }, []);

  return {
    config,
    setConfig,
  }
}